export const REQUEST_REFERENCE = "request_reference"
export const REFERENCE_SUCCESS = "reference_success"
export const REFERENCE_FAILURE = "reference_failure"
export const INSERT_NOTES_IN_REFERENCE = "insert_notes_in_reference"
export const REMOVE_REFERENCE = "remove_reference"

export const CLEAR_REFERENCE_CLEAR = "clear_reference_clear"